export const isJWTValid = (jwt: string) => {
  try {
    const payload = JSON.parse(atob(jwt.split('.')[1]));

    console.log(payload);

    return payload.exp < Date.now();
  } catch {
    return true; // malformed token = invalid
  }
};
